import axios from 'axios'
import store from '../store'
import errors from './errors'

export default {
  getAuthenticationHeader () {
    return {withCredentials: true}
  },
  get (url) {
    return new Promise((resolve, reject) => {
      axios.get(url, this.getAuthenticationHeader())
        .then(response => {
          store.commit('setIsAuthenticated', true) //  Always be checking authorization.
          resolve(response)
        })
        .catch(error => {
          errors.handleRejectedCall(error)
          reject(error)
        })
    })
  },
  getWithParams (url, params) {
    return new Promise((resolve, reject) => {
      axios.get(url, {params: params, withCredentials: true})
        .then(response => {
          store.commit('setIsAuthenticated', true) //  Always be checking authorization.
          resolve(response)
        })
        .catch(error => {
          errors.handleRejectedCall(error)
          reject(error)
        })
    })
  },
  post (url, data) {
    return new Promise((resolve, reject) => {
      axios.post(url, data, this.getAuthenticationHeader())
        .then(response => {
          store.commit('setIsAuthenticated', true) //  Always be checking authorization.
          resolve(response)
        })
        .catch(error => {
          errors.handleRejectedCall(error)
          reject(error)
        })
    })
  },
  upload (url, data) {
    return new Promise((resolve, reject) => {
      axios.post(url, data, {
        withCredentials: true,
        'Content-Type': 'multipart/form-data'
      })
        .then(response => {
          store.commit('setIsAuthenticated', true) //  Always be checking authorization.
          resolve(response)
        })
        .catch(error => {
          errors.handleRejectedCall(error)
          reject(error)
        })
    })
  },
  put (url, data) {
    return new Promise((resolve, reject) => {
      axios.put(url, data, this.getAuthenticationHeader())
        .then(response => {
          store.commit('setIsAuthenticated', true) //  Always be checking authorization.
          resolve(response)
        })
        .catch(error => {
          errors.handleRejectedCall(error)
          reject(error)
        })
    })
  },
  deleteCall (url) {
    return new Promise((resolve, reject) => {
      axios.delete(url, this.getAuthenticationHeader())
        .then(response => {
          store.commit('setIsAuthenticated', true) //  Always be checking authorization.
          resolve(response)
        })
        .catch(error => {
          errors.handleRejectedCall(error)
          reject(error)
        })
    })
  },
  authenticateIntuit (code, realmID) {
    const url = process.env.ROOT_API + '/authenticate_intuit'
    return new Promise((resolve, reject) => {
      axios.post(url, {'code': code, 'realmID': realmID}, this.getAuthenticationHeader())
        .then(response => {
          resolve(response)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  authenticateLinkedin (code, state, source) {
    const url = process.env.ROOT_API + '/authenticate_linkedin'
    return new Promise((resolve, reject) => {
      axios.post(url, {'code': code, 'state': state, 'source': source}, this.getAuthenticationHeader())
        .then(response => {
          resolve(response)
        })
        .catch(response => {
          reject(response)
        })
    })
  },
  enqueueCall (url, params = null) {
    let jobID = null
    let pollID = null
    return new Promise((resolve, reject) => {
      axios.get(url, {params: params, withCredentials: true})
        .then(response => {
          if (response.data.status === 'finished') {
            clearInterval(pollID)
            resolve(response.data)
            return
          }
          jobID = response.data.id
          pollID = setInterval(
            () => {
              axios.get(process.env.ROOT_API + '/queue/' + jobID, this.getAuthenticationHeader())
                .then(response => {
                  if (response.data.status === 'finished') {
                    clearInterval(pollID)
                    resolve(response.data)
                  }
                })
                .catch(error => {
                  clearInterval(pollID)
                  errors.handleRejectedCall(error)
                  reject(error)
                })
            }, 2000)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  enqueueJob (url, data) {
    let jobID = null
    let pollID = null
    return new Promise((resolve, reject) => {
      axios.post(url, data, this.getAuthenticationHeader())
        .then(response => {
          if (response.data.status === 'finished') {
            clearInterval(pollID)
            resolve(response.data)
            return
          }
          jobID = response.data.id
          pollID = setInterval(
            () => {
              axios.get(process.env.ROOT_API + '/queue/' + jobID, this.getAuthenticationHeader())
                .then(response => {
                  if (response.data.status === 'finished') {
                    clearInterval(pollID)
                    resolve(response.data)
                  }
                })
                .catch(error => {
                  errors.handleRejectedCall(error)
                  clearInterval(pollID)
                  store.commit('setError', error)
                  reject(error)
                })
            }, 2000)
        })
        .catch(error => {
          errors.handleRejectedCall(error)
          store.commit('setError', error)
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/_services.js